//#region IMPORTS
import { DELIVERY_ADDRESS_CODE } from "../../models/_consts";
import { StoreAddress } from "../../models/store";
import StoreDetailsAddressListItem from "./StoreDetailsAddressListItem";
//#endregion

//#region INTERFACE
interface Props {
  addresses: StoreAddress[];
  type?: number;
}
//#endregion

export default function StoreDetailsAddressList({
  addresses,
  type = 0,
}: Props) {
  //#region RENDER
  return addresses.length === 0 ? null : (
    <div className="sm:col-span-3">
      <h4 className="block text-sm font-bold leading-6 text-gray-400 mb-2">
        {`${
          type === DELIVERY_ADDRESS_CODE
            ? "Delivery Address"
            : type !== 0
            ? "Billing Address"
            : "Address"
        }${addresses.length > 1 ? "es" : ""}`}
      </h4>
      <ul className="divide-gray-100 border-gray-200 border text-slate-800 divide-y rounded-md">
        {addresses.map((address, index) => (
          <StoreDetailsAddressListItem key={index} address={address} />
        ))}
      </ul>
    </div>
  );
  //#endregion
}
